import styled, { css } from 'styled-components';

interface Props {
  $pinnedPosition?: boolean;
  $pinBottom?: boolean;
}

function pinnedPositionStyle({ $pinnedPosition = false }: Props) {
  if ($pinnedPosition) {
    return css`
      position: relative;
      width: 100%;
    `;
  }
}

function pinBottomStyle({ $pinBottom = false }: Props) {
  if ($pinBottom) {
    return css`
      height: 100%;
      display: flex;
      align-items: flex-end;
    `;
  }
}

export default styled.div<Props>`
  ${pinnedPositionStyle}
  ${pinBottomStyle}
`;
